import React from 'react'
import { Grid, Typography, TextareaAutosize } from '@material-ui/core/'
import { DialogModal, Button } from '../../../components/UI'
import checkedUserStory from '../../../assetss/img/checkedUserStory.svg'
import '../index.scss'

const GoToMeetMessage = ({ open, onClose, content, tellMeHandler, name, onChange, value, defaultValue }) => (
  <DialogModal
    open={open}
    top='40%'
    width='90%'
    maxWidth='320px'
    height='100%'
    maxHeight={content ? '294px' : '332px'}
    onClose={onClose}
  >
    <Grid className='modalMeetStory' container direction='column' justify='space-between'>
      {content ? (
        <>
          <Typography className='titleModalMeet' align='center'>
            Meeting request has been<br />successfully sent!
          </Typography>
          <Typography className='requestSuccessful'>
            <img className='checkedUserIcon' src={checkedUserStory} alt='checkedUserStory' />
            Please note that receiving the answer might take a few hours or more due to the time zone differences.
          </Typography>
          <Button onClick={onClose} className='customBtnModal'>Ok</Button>
        </>
      ) : (
        <>
          <Typography className='titleModalMeet' align='center'>
            You’re asking {name} to meet you:
          </Typography>
          <Typography className='requestMessage' align='left'>Request message:</Typography>
          <TextareaAutosize
            maxLength={180}
            className='customInput'
            value={value}
            defaultValue={defaultValue}
            onChange={onChange}
            rowsMin={4}
          />
          <Button onClick={tellMeHandler} className='customBtnModal'>Send meeting request</Button>
        </>
      )}
    </Grid>
  </DialogModal>
)

export default GoToMeetMessage
